// extracted by mini-css-extract-plugin
module.exports = {"perkSearch":"PerkSearch_perkSearch__80k62","input":"PerkSearch_input__PqbCD","container":"PerkSearch_container__Nf_XE","resultContainer":"PerkSearch_resultContainer__0upwA"};